var _script, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRerc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Premier_plan",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 92 92",
    overflow: "visible",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _script || (_script = /*#__PURE__*/React.createElement("script", {
    xmlns: ""
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    fill: "#FFBE00",
    d: "M71.3000031,92.0000076H20.6999989C9.267705,92.0000076,0,82.7323074,0,71.3000107V20.7000008  C0,9.2677059,9.2677059,0,20.7000008,0h50.6000023C82.7322922,0,92,9.267705,92,20.6999989v50.6000137  C92,82.7323074,82.7322922,92.0000076,71.3000031,92.0000076z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    d: "M48.1211967,71.4943085c-12.3552399,0-24.1572628-8.144146-24.1572628-24.9842148  c0-14.5623569,8.4884663-26.2260723,24.1572628-26.2260723c6.0047379,0,10.4218521,1.2418633,13.9399834,2.8294888  l-3.5181313,8.9033813c-3.175251-1.795084-6.7654152-2.6220322-9.8715134-2.6220322  c-7.4540596,0-13.5250702,4.8997383-13.5250702,16.6326103c0,11.1810875,7.3157539,16.3574371,14.3549004,16.3574371  c3.8638916,0,7.3157539-1.1741486,9.7303276-2.6234703l2.8986397,8.3516006  C58.4047432,70.1141357,53.0886497,71.4943085,48.1211967,71.4943085z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRerc);
export default __webpack_public_path__ + "static/media/rerc.6adbbe3d43dbb5d0540d017390609072.svg";
export { ForwardRef as ReactComponent };